const firebaseConfig = {
    apiKey: "AIzaSyB1fFIHnblpGi9aFRXvuGr14SIQFiPHIWE",
    authDomain: "e-tickets-booking.firebaseapp.com",
    projectId: "e-tickets-booking",
    storageBucket: "e-tickets-booking.appspot.com",
    messagingSenderId: "218316822296",
    appId: "1:218316822296:web:99b8b65b8bbf5b7f63306d"
}

export default firebaseConfig;